import { baseApi } from "../../../../core/data/rtk/baseQuery";
import { ApiResponseType } from "../../../../core/data/rtk/apiResponseType";
import { FeeConfigResponseType, Data } from "../types/feeConfigResponse";
import { FeeConfigPayloadType } from "../types/feeConfigRequest";

export const feeConfigApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllFeeConfig: builder.query<
      ApiResponseType<Data>,
      { size?: number; search?: string; page?: number }
    >({
      query: (params) => {
        const queryParams = new URLSearchParams();
        if (params?.size) queryParams.append("size", params.size.toString());
        if (params?.search) queryParams.append("search", params.search);
        if (params?.page) queryParams.append("page", params.page.toString());

        return `course-fee/get-all?${queryParams.toString()}`;
      },
      providesTags: ["FeeConfig"],
    }),
    addFeeConfig: builder.mutation<
      ApiResponseType<{ feeConfig: FeeConfigResponseType }>,
      FeeConfigPayloadType
    >({
      query: (payload) => ({
        url: "course-fee/save",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["FeeConfig"],
    }),
    getFeeConfigById: builder.query<
      ApiResponseType<{ coursefee: FeeConfigResponseType }>,
      { id: string }
    >({
      query: ({ id }) => `course-fee/get/${id}`,
      providesTags: ["FeeConfig"],
    }),
    updateFeeConfig: builder.mutation<
      ApiResponseType<{ feeConfig: FeeConfigResponseType }>,
      { id: string; payload: FeeConfigPayloadType }
    >({
      query: ({ id, payload }) => ({
        url: `course-fee/update/${id}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["FeeConfig"],
    }),
    deleteFeeConfig: builder.mutation<
      ApiResponseType<{ deleted: true }>,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `course-fee/delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["FeeConfig"],
    }),
    attachCenters: builder.mutation<
      ApiResponseType<{ feeconfig: FeeConfigResponseType }>,
      { id: string; payload: { center_ids: number[] } }
    >({
      query: ({ id, payload }) => ({
        url: `course-fee/attach-to-centers/${id}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["FeeConfig", "Centers"],
    }),
    detachCenters: builder.mutation<
      ApiResponseType<{ feeconfig: FeeConfigResponseType }>,
      { id: string; payload: { center_ids: number[] } }
    >({
      query: ({ id, payload }) => ({
        url: `course-fee/detach-from-centers/${id}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["FeeConfig", "Centers"],
    }),
  }),
});

export const {
  useGetAllFeeConfigQuery,
  useAddFeeConfigMutation,
  useGetFeeConfigByIdQuery,
  useUpdateFeeConfigMutation,
  useDeleteFeeConfigMutation,
  useAttachCentersMutation,
  useDetachCentersMutation,
} = feeConfigApi;
